
enum ProcessType {
  generic = 'generic',
  expert = 'expert'
}

export default ProcessType;
